import { createSlice } from '@reduxjs/toolkit'

import { alertsSelectors } from '../selectors/alerts'

const initialState = {
    items: [],
    isLoading: true,
    isRefreshing: false,
    error: null,
}

const alerts = createSlice({
    name: 'alerts',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setRefreshing: (state, action) => {
            state.isRefreshing = action.payload
        },
        setItems: (state, action) => {
            state.items = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
        },
    },
    selectors: {
        ...alertsSelectors,
    },
})

export const alertsSelector = alerts.getSelectors()
export const alertsActions = alerts.actions

export default alerts.reducer
